import React from 'react';
import Layout from '../components/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Compass, Lightning, MagnifyingGlassPlus, ChartBar, Coins, Broadcast } from '@phosphor-icons/react';

import ChartinkTab from './market-intel/ChartinkTab';
import ScreenerTab from './market-intel/ScreenerTab';
import TradingViewTab from './market-intel/TradingViewTab';
import OptionsAnalyticsTab from './market-intel/OptionsAnalyticsTab';
import LiveNseBseTab from './market-intel/LiveNseBseTab';

const TABS = [
  { value: 'live', label: 'Live NSE/BSE', Icon: Broadcast, Component: LiveNseBseTab, testid: 'tab-live-nsebse' },
  { value: 'chartink', label: 'Chartink Scans', Icon: Lightning, Component: ChartinkTab, testid: 'tab-chartink' },
  { value: 'screener', label: 'Screener.in', Icon: MagnifyingGlassPlus, Component: ScreenerTab, testid: 'tab-screener' },
  { value: 'tradingview', label: 'TradingView', Icon: ChartBar, Component: TradingViewTab, testid: 'tab-tradingview' },
  { value: 'options', label: 'Options Analytics', Icon: Coins, Component: OptionsAnalyticsTab, testid: 'tab-options-analytics' },
];

export default function MarketIntel() {
  return (
    <Layout>
      <div className="w-full max-w-[1920px] mx-auto px-6 py-6" data-testid="market-intel-page">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-white flex items-center gap-3">
            <Compass size={32} weight="duotone" className="text-[#2563EB]" />
            Market Intel
          </h1>
          <p className="text-sm text-[#94A3B8] mt-1">
            Live NSE/BSE data + aggregated intelligence from Chartink, Screener.in, TradingView & NSE options.
          </p>
        </div>

        <Tabs defaultValue="live" className="w-full">
          <TabsList className="bg-white/5 border border-white/10 mb-6" data-testid="market-intel-tabs">
            {TABS.map(({ value, label, Icon, testid }) => (
              <TabsTrigger
                key={value}
                value={value}
                className="data-[state=active]:bg-[#2563EB] data-[state=active]:text-white"
                data-testid={testid}
              >
                <Icon size={14} className="mr-1.5" /> {label}
              </TabsTrigger>
            ))}
          </TabsList>

          {TABS.map(({ value, Component }) => (
            <TabsContent key={value} value={value}><Component /></TabsContent>
          ))}
        </Tabs>
      </div>
    </Layout>
  );
}
